import './styles/app.css';
import { addRouteListener, route, setFallback, startRouter } from './ui/router';
import { el, page } from './ui/dom';
import { lockAdminMode, setsScreen } from './ui/screens/sets';
import { importScreen } from './ui/screens/import';
import { learnScreen } from './ui/screens/learn';
import { quizScreen } from './ui/screens/quiz';
import { statsScreen } from './ui/screens/stats';
import { transferScreen } from './ui/screens/transfer';
import { seedSampleSetOnce } from './core/sample';
import { initSpeech } from './core/tts';

seedSampleSetOnce();
initSpeech();

route('/sets', setsScreen);
route('/import', importScreen);
route('/edit/:id', importScreen);
route('/learn/:id', learnScreen);
route('/quiz/:id', quizScreen);
route('/stats/:id', statsScreen);
route('/transfer', transferScreen);

// The admin mode must not survive leaving the start screen.
addRouteListener(lockAdminMode);

setFallback(() =>
  page({
    title: 'Nicht gefunden',
    back: '/sets',
    children: [
      el('div', { class: 'card' }, [el('p', { text: 'Diese Seite gibt es nicht.' })]),
    ],
  }),
);

const mount = document.getElementById('app');
if (mount) startRouter(mount);
